import { useEffect, useState } from "react";

import { register } from "../api/axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../components/Loader";
// Import toastify css file
import "react-toastify/dist/ReactToastify.css";

// toast-configuration method,
// it is compulsory method.

import { useNavigate, Link } from "react-router-dom";
import { useUser, useSetUser } from "../context/userContext";
const SignIn = () => {
  const navigate = useNavigate();
  const user = useUser();
  const setUser = useSetUser();
  const [usn, setUsn] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");

  const [navi, setNavi] = useState(false);
  const [loading, setLoading] = useState(false);
  const css = " p-3  w-full outline-none border-2 border-gray-300 bg-white m-3";

  const onSubmit = async () => {
    if (loading === false) {
      setLoading(true);
      await register({ usn, password, username })
        .then((response) => {
          if (response.data.statusCode !== 200) {
            toast.error(response.data.message || "something went wrong");
          } else {
            setUser(response.data);

            localStorage.setItem("refreshToken", response.data.refreshToken);
            toast("welcome!!!");
            console.log(setUser);
            console.log(user);
          }
        })
        .catch((e) => {
          // alert(e.message || "something went wrong");
          toast.error(e.message || "something went wrong");
        })
        .finally(() => {});
    }
  };

  useEffect(() => {
    console.log(user);
    if (user?.user?.usn != null) {
      setNavi(true);
    }
  }, [user]);

  useEffect(() => {
    if (navi) {
      navigate("/");
    }
  }, [navi, navigate]);
  return (
    <div className="flex  justify-center items-center h-screen flex-col">
      <div className="flex justify-center items-center flex-col border-gray-100 border-2 p-3">
        <img src={require("./../login.jpeg")} alt="" className="loggo"/>

        <input
          type="text"
          className={`${css}`}
          placeholder="username"
          onChange={(e) => {
            setUserName(e.target.value);
          }}
        />

        <input
          type="text"
          className={`${css}`}
          placeholder="usn"
          onChange={(e) => {
            setUsn(e.target.value);
          }}
        />
        <input
          className={`${css}`}
          type="password"
          placeholder="password"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <div
          className={`p-3 inline-block w-full text-center outline-none border-2 border-gray-300 m-3 bg-blue-600 text-white  ${
            loading ? "disabled" : "cursor-pointer"
          }`}
          onClick={() => {
            onSubmit();
          }}
        >
          {loading ? <Loader size="20%" color="white" /> : "Sign Up"}
        </div>
        <div className=" border-gray-100 border-2 p-3  my-3 w-full text-center">
          Have an account?{" "}
          <Link to="/login" className="text-blue-500">
            login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
